export default function StatCard({ icon: Icon, label, value, sub, color }) {
  return (
    <div className="bg-white rounded-xl p-5 border" style={{ borderColor: '#E5E7EB' }}>
      <div className="flex items-center justify-between mb-3">
        <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: color + '20' }}>
          <Icon size={18} style={{ color }} />
        </div>
        {sub !== undefined && (
          <span className="text-xs font-semibold px-2 py-0.5 rounded-full" style={{ backgroundColor: '#FEF3C7', color: '#92400E' }}>
            +{sub} today
          </span>
        )}
      </div>
      <div className="font-heading font-black text-3xl" style={{ color: '#0A3F22' }}>{value}</div>
      <div className="text-sm mt-1" style={{ color: '#6B7280' }}>{label}</div>
    </div>
  );
}
